import store from './store';

export const setDeferredPrompt = store.create.set('deferredPrompt');
export const setIsTourOpen = store.create.set('isTourOpen');
export const setIsSidebarOpen = store.create.set('isSidebarOpen');
export const setIsNavigationOpen = store.create.set('isNavigationOpen');

// TODO: Get rid of

export const setMode = store.create.set('mode');

export const toggleActive = () => (dispatch, getState) => {
  // const isActive = getIsActive(getState());
  // dispatch(setActive(!isActive));
};
